export default __webpack_public_path__ + "static/media/cart-shoppingHover.1d16ff00.svg";